import React, { useState, useEffect } from 'react';
import { FaBars,FaPhone ,FaTimes } from 'react-icons/fa';
import {  useLocation, useNavigate } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (sectionId) => {
    if (sectionId === "hero") {
      // special case for homepage scroll
      if (location.pathname === "/") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        navigate("/");
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, 100);
      }
      return;
    }

    if (location.pathname === "/") {
      // already on homepage -> just scroll
      const section = document.getElementById(sectionId);
      if (section) {
        const navbar = document.querySelector("nav"); 
        const yOffset = navbar ? -navbar.offsetHeight : 0; 
        const extraOffset = window.innerWidth < 768 ? 350 : 0;
        const y =
          section.getBoundingClientRect().top + window.pageYOffset + yOffset + extraOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    } else {
      // navigate to homepage, then scroll after render
      navigate("/");
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          const navbar = document.querySelector("nav");
          const yOffset = navbar ? -navbar.offsetHeight : 0;
          const extraOffset = window.innerWidth < 768 ? 250 : 0;
          const y =
            section.getBoundingClientRect().top +
            window.pageYOffset +
            yOffset +
            extraOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 100); // wait a bit for homepage to render
    }
  };

    const handleSubmit = (e) => {
    e.preventDefault();

    const phoneNumber = process.env.REACT_APP_PHONE_NUMBER; // <-- WhatsApp number in international format

    const message = `Bonjour, je veux prendre un rendez-vous pour une consultation.`;

    const encodedMessage = encodeURIComponent(message);

    window.open(
      `https://wa.me/${phoneNumber}?text=${encodedMessage}`,
      "_blank"
    );
  };
  
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-white shadow-lg backdrop-blur-md bg-opacity-95"
          : "bg-transparent"
      }`}
    >
      <div className="container-custom">
        <div className="flex items-center justify-between py-6">
          {/* Logo */}
          <div
            className="flex items-center space-x-2 cursor-pointer hover:opacity-90 transition-opacity"
            onClick={() => handleNavClick("hero")}
          >
            <img
              src="/images/logo_horizontal_no_background.png"
              alt="DentalCare Logo"
              className="h-16 sm:h-18 md:h-20 w-auto object-contain"
            />
          </div>

          {/* Phone Button */}
          <a
            href={`tel:${process.env.REACT_APP_PHONE_NUMBER}`}
            className="flex items-center space-x-2 bg-white-500 text-blue-500 px-4 py-2 rounded-lg shadow hover:bg-gray-200 transition-colors duration-300"
          >
            <FaPhone className="text-2xl text-primary-500" />
            <span className="font-medium">07 08 44 44 54</span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
              {/* Homepage */}
              <button
                onClick={() => handleNavClick("hero")}
                className="text-gray-700 hover:text-primary-500 font-medium transition-colors duration-300"
              >
                Accueil
              </button>
              {/* Scroll or redirect + scroll */}
              <button
                onClick={() => handleNavClick("about")}
                className="text-gray-700 hover:text-primary-500 font-medium transition-colors duration-300"
              >
                À propos
              </button>
              <button
                onClick={() => handleNavClick("services")}
                className="text-gray-700 hover:text-primary-500 font-medium transition-colors duration-300"
              >
                Services
              </button>
              <button
                onClick={() => handleNavClick("team")}
                className="text-gray-700 hover:text-primary-500 font-medium transition-colors duration-300"
              >
                Équipe
              </button>
              <button
                onClick={() => handleNavClick("contact")}
                className="text-gray-700 hover:text-primary-500 font-medium transition-colors duration-300"
              >
                Contact
              </button>
            <button onClick={handleSubmit} className="btn-primary">
              Prendre rendez-vous
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-700 hover:text-primary-500"
          >
            {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden bg-white shadow-lg rounded-lg mt-2 py-4">
            <div className="flex flex-col space-y-2 px-4">
              <nav className="flex flex-col space-y-2">
                {/* Homepage */}
                <button
                  onClick={() => handleNavClick("hero")}
                  className="text-gray-700 hover:text-primary-500 font-medium text-left py-2 transition-colors duration-300"
                >
                  Accueil
                </button>
                {/* Scroll or redirect + scroll */}
                <button
                  onClick={() => handleNavClick("about")}
                  className="text-gray-700 hover:text-primary-500 font-medium text-left py-2 transition-colors duration-300"
                >
                  À propos
                </button>
                <button
                  onClick={() => handleNavClick("services")}
                  className="text-gray-700 hover:text-primary-500 font-medium text-left py-2 transition-colors duration-300"
                >
                  Services
                </button>
                <button
                  onClick={() => handleNavClick("team")}
                  className="text-gray-700 hover:text-primary-500 font-medium text-left py-2 transition-colors duration-300"
                >
                  Équipe
                </button>
                <button
                  onClick={() => handleNavClick("contact")}
                  className="text-gray-700 hover:text-primary-500 font-medium text-left py-2 transition-colors duration-300"
                >
                  Contact
                </button>
              </nav>
              <button onClick={handleSubmit} className="btn-primary w-full">
                Prendre rendez-vous
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 